import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface workOrderFilter {
  queryParams: string
  searchFilter: string
  currentPage: number
  pageSize: number
  dateFrom: string
  dateTo: string
  selectedOrderStatus: string[]
  selectedPaymentQuotationStatus: string[]
}

const initialState: workOrderFilter = {
  queryParams: '',
  searchFilter: '',
  currentPage: 1,
  pageSize: 50,
  dateFrom: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0],
  dateTo: new Date().toISOString().split('T')[0],
  selectedOrderStatus: [],
  selectedPaymentQuotationStatus: [],
}

const workOrderSlice = createSlice({
  name: 'work-order',
  initialState,
  reducers: {
    setQueryParams(state, action: PayloadAction<string>) {
      state.queryParams = action.payload
    },
    setSearchFilter(state, action: PayloadAction<string>) {
      state.searchFilter = action.payload
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload
    },
    setDateFrom(state, action: PayloadAction<string>) {
      state.dateFrom = action.payload
    },
    setDateTo(state, action: PayloadAction<string>) {
      state.dateTo = action.payload
    },
    setSelectedOrderStatus(state, action: PayloadAction<string[]>) {
      state.selectedOrderStatus = action.payload
    },
    setSelectedPaymentQuotationStatus(state, action: PayloadAction<string[]>) {
      state.selectedPaymentQuotationStatus = action.payload
    },
    resetFilters(state) {
      state.queryParams = ''
      state.searchFilter = ''
      state.dateFrom = new Date(new Date().setDate(new Date().getDate() - 7))
        .toISOString()
        .split('T')[0]
      state.dateTo = new Date().toISOString().split('T')[0]
      state.currentPage = 1
      state.pageSize = 10
      state.selectedOrderStatus = []
      state.selectedPaymentQuotationStatus = []
    },
  },
})

export const {
  setQueryParams,
  setSearchFilter,
  setCurrentPage,
  setPageSize,
  setDateFrom,
  setDateTo,
  setSelectedOrderStatus,
  setSelectedPaymentQuotationStatus,
  resetFilters,
} = workOrderSlice.actions

export default workOrderSlice.reducer
